import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {PRIVACY_POLICY_URL, LEGAL_URL} from '../../config/DEConstants';
const LOCALE_PREFIX = 'DE/components/Footer/Footer';

export class FooterLinks extends Component {
    static propTypes = {
        showFeedbackLink: PropTypes.bool,
        // Passed in props
        showLinks: PropTypes.bool,
        locale: PropTypes.string
    };

    static defaultProps = {
        showFeedbackLink: false,
        showLinks: true
    };

    handleClickFeedback = event => {
        event.preventDefault();
        window.launchOpinionLabStandardFeedback(event);
    };

    render() {
        const { showFeedbackLink, showLinks, locale } = this.props;
        const year = new Date().getFullYear();

        return (
            <div className="footerLinks-gb">

                {showLinks && [(
                    <a
                        href={`${LEGAL_URL}${locale}`}
                        data-automation-id="legal-url"
                        className="cue-footer-link"
                        target="_blank"
                        key="legal"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.imprint`}
                        />
                    </a>
                ), (
                    <a
                        href={`${PRIVACY_POLICY_URL}${locale}`}
                        data-automation-id="privacy-url"
                        className="cue-footer-link"
                        target="_blank"
                        key="privacy"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.privacy`}
                        />
                    </a>
                )]}

                {showFeedbackLink && (
                    <a
                        href="#"
                        data-automation-id="feedback-link"
                        className="cue-footer-link oo-feedback"
                        name="PayPalFeedback-Footer"
                        onClick={this.handleClickFeedback}
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.feedback`}
                        />
                    </a>
                )}

                <div className="security-footer">
                    <span className="cue-footer-link">© 1999-{year}</span>
                    <div id="cue-security-icon" />
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    showFeedbackLink: _.get(state, 'serverData.featureFlags.wireOnFeedback'),
    locale: _.get(state, 'serverData.locale.locale', 'de_DE')
});

export default connect(mapStateToProps)(FooterLinks);
